import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import OrganizationForm from './organizationForm'
import { fetchOrganization, updateOrganization } from '../../actions/organizationActions'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'

const OrganizationEditComponent = ({ match, dispatch, history, initialValues }) => {
  const id = match.params.id

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    let mounted = true
    const load = async () => {
      setLoading(true)
      try {
        await dispatch(fetchOrganization(id))
      } finally {
        if (mounted) setLoading(false)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [dispatch, id])

  const onSubmit = (values) =>
    dispatch(updateOrganization(id, values)).then(() =>
      history.push(`/organizations/${id}`)
    )

  const levels = [
    { label: 'Index ', path: '/' },
    { label: 'Organizations', path: '/organizations' },
    { label: 'Edit', path: '' },
  ]

  const mappedInitial = initialValues
    ? {
        ...initialValues,
        addressId: initialValues.address?.id || initialValues.addressId || '',
        addressLine1: initialValues.address?.line1 || '',
        addressLine2: initialValues.address?.line2 || '',
        city: initialValues.address?.city || '',
        state: initialValues.address?.state || '',
        zip: initialValues.address?.zip || '',
      }
    : initialValues

  return (
    <>
      <Breadcrumb levels={levels} />
      <LoadingSection isLoading={loading}>
        <div className="index index__drive-america">
          <h1 className="index-table__header">Edit Organization</h1>
          <OrganizationForm onSubmit={onSubmit} initialValues={mappedInitial} />
        </div>
      </LoadingSection>
    </>
  )
}

export default connect((state) => ({
  initialValues: state.organizations.current,
}))(OrganizationEditComponent)
